import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CommitteeView, getCommitteeOptions } from '@/module/Author/Committee';

export const Route = createFileRoute('/_auth/author/_author/committee/_committee/$committeeId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { committeeId } = Route.useParams();
  const { data: committee } = useSuspenseQuery(getCommitteeOptions(committeeId));

  return <CommitteeView committee={committee} />;
}
